import React from 'react';
import SearchableDropdown from '../SearchableDropdown/SearchableDropdown';
import IntentSlot from '../../types/BotBuilder/IntentSlot';
import Slot from '../../types/BotBuilder/Slot';
import { SystemVariableDto } from '../../services/SystemVariableService/SystemVariableService';
import useVariableDropdownLogic from '../../hooks/useVariableDropdownLogic';

interface FloatingVariableDropdownProps {
  intentSlots?: IntentSlot[];
  globalSlots?: Slot[];
  systemVariables: SystemVariableDto[];
  onSelect: (varName: string, isSystem: boolean, isGlobal?: boolean) => void;
  onClose: () => void;
  position: { top: number; left: number };
  isOpen: boolean;
}

function FloatingVariableDropdown({
  intentSlots = [],
  globalSlots = [],
  systemVariables,
  onSelect,
  onClose,
  position,
  isOpen
}: Readonly<FloatingVariableDropdownProps>): React.ReactElement {
  const { filteredItems, handleSearch, handleSelect } =
    useVariableDropdownLogic({
      intentSlots,
      globalSlots,
      systemVariables,
      onSelect
    });

  return (
    <SearchableDropdown
      items={filteredItems}
      selectedItem={null}
      onSelect={handleSelect}
      onSearch={handleSearch}
      onClose={onClose}
      searchPlaceholder='Search variables...'
      emptyText='No variables available'
      floatingMode={isOpen}
      position={position}
    />
  );
}

export default FloatingVariableDropdown;
